// extracted by mini-css-extract-plugin
module.exports = {"root":"_2ukt6","bg":"_1K1h"};